var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobalSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_global-search",
    "data-name": "vuesax/outline/global-search",
    transform: "translate(-684 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "global-search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.75,21.5A10.75,10.75,0,1,1,21.5,10.75a.75.75,0,0,1-1.5,0A9.25,9.25,0,1,0,10.75,20a.75.75,0,0,1,0,1.5Z",
    transform: "translate(685.25 189.25)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M2.2,19.5h-1a.755.755,0,0,1-.75-.75.745.745,0,0,1,.73-.75,29.49,29.49,0,0,1,0-16.5A.75.75,0,0,1,1.2,0h1a.767.767,0,0,1,.61.31.751.751,0,0,1,.1.68,27.948,27.948,0,0,0,0,17.53.751.751,0,0,1-.1.68A.731.731,0,0,1,2.2,19.5Z",
    transform: "translate(690.803 190.25)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M2.208,10.5a.755.755,0,0,1-.75-.75A27.757,27.757,0,0,0,.038.988a.749.749,0,1,1,1.42-.48,29.268,29.268,0,0,1,1.5,9.24A.755.755,0,0,1,2.208,10.5Z",
    transform: "translate(698.251 190.252)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M9.75,2.961A29.134,29.134,0,0,1,1.5,1.771.75.75,0,0,1,0,1.751v-1A.767.767,0,0,1,.31.141a.751.751,0,0,1,.68-.1,27.757,27.757,0,0,0,8.76,1.42.75.75,0,1,1,0,1.5Z",
    transform: "translate(686.25 202.249)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M18.758,2.953a.672.672,0,0,1-.24-.04,27.948,27.948,0,0,0-17.53,0,.749.749,0,0,1-.48-1.42,29.318,29.318,0,0,1,18.47,0,.753.753,0,0,1,.47.95A.708.708,0,0,1,18.758,2.953Z",
    transform: "translate(686.242 194.797)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M3.95,7.9A3.95,3.95,0,1,1,7.9,3.95,3.952,3.952,0,0,1,3.95,7.9Zm0-6.4A2.45,2.45,0,1,0,6.4,3.95,2.454,2.454,0,0,0,3.95,1.5Z",
    transform: "translate(698.25 202.25)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M1.747,2.5a.742.742,0,0,1-.53-.22l-1-1A.75.75,0,0,1,1.277.218l1,1a.755.755,0,0,1,0,1.06A.742.742,0,0,1,1.747,2.5Z",
    transform: "translate(704.252 208.252)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-8",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(708 212) rotate(180)",
    fill: "#061133",
    opacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalSearch);
export default __webpack_public_path__ + "static/media/global-search.9e6f487fc0f887b9d35d311d9634569c.svg";
export { ForwardRef as ReactComponent };